import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()

export class SharedPanelService {

    public switched = new Subject<boolean>();
    submit = new Subject<boolean>();
    constructor( private http: HttpClient ) {
    }
    observerisSwitchedOn() {
      return this.switched.asObservable();
    }

    actualizarLight(switchedOn) {
        this.switched.next(switchedOn);
    }

    printBillOR(url: string ,params: object){
      /*return this.http.post(_URL_,params);*/
      this.submit.next(true);
      const mapForm = document.createElement('form');
      mapForm.target = 'reportView';
      mapForm.method = 'POST';
      mapForm.action = url;
      Object.keys(params).forEach(function(param) {
        const mapInput = document.createElement('input');
        mapInput.type = 'hidden';
        mapInput.name = param;
        mapInput.setAttribute('value', params[param] === null ? '' : params[param]);
        mapForm.appendChild(mapInput);
      });
      document.body.appendChild(mapForm);
      mapForm.submit();
      setTimeout(() => {
        document.body.removeChild(mapForm);
      }, 500);
    }
    
}

